import React, { useState, useEffect, useContext, useRef } from "react";
import ErrorComponent from "./Error";
import auth0 from "auth0-js/dist/auth0.min.js";

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import ErrorUtils from '../utils/ErrorUtils';

import Dialog from "./Dialog";

import TitleContext from "../contexts/Title";
import LanguageContext from "../contexts/Language";
import UtilContext from "../contexts/Util";
import UserDataContext from "../contexts/UserData";
import StatusContext from "../contexts/Status";

import AppConfig from "../AppConfig";

export default function RegistrationRouter({ disableAcceptBtn, socialLogin, config, loadRegisterDocuments, registerEmail, registerPhone, registerCode, registerPhoneCode, registerUser, registerPhoneUser, show_doc, openDoc, openAdditionalTos, setGlobalError, client_conns, view_disabled, checkPasswordPolicy, password_valid, setPasswordValid, checkRecaptcha, default_phone_region }) {
  // ===========================================================
  // React Variables
  // ===========================================================
  // -----------------------------
  // Context
  // -----------------------------
  const { page_status } = useContext(StatusContext);
  const { getTag } = useContext(LanguageContext);
  const { user_data } = useContext(UserDataContext);
  // -------------------------------
  // State
  // -----------------------------
  const [occuredError, setOccuredError] = useState(false);
  // -----------------------------
  // Ref
  // -----------------------------
  const errorData = useRef(null);

  // ===========================================================
  // Methods
  // ===========================================================
  /***************************
   * ダイアログを閉じる処理
   * 
   * エラー状態をリセットし、ダイアログを閉じる
   ***************************/
  const closeDialog = () => {
    setOccuredError(false);
    errorData.current = null;
    Dialog(false);
  }

  // ----------------------------------------------------------
  // useEffect
  // ----------------------------------------------------------
  /***************************
   * 初期処理（初回のみ）
   ***************************/
  useEffect(() => {
    // すでにReCAPTCHA用の要素がルートと同列に存在している場合削除する
    var targets = document.querySelectorAll(".g-recaptcha-bubble-arrow");
    for (var i = 0; i < targets.length; i++) {
      targets[i].parentNode.remove();
    }
  }, []);

  /***************************
   * 画面遷移時の処理
   ***************************/
  useEffect(() => {
    // エラー状態をリセットし、ダイアログが開いている場合はそれを閉じる
    closeDialog();
  }, [page_status]);

  /***************************
   * エラー発生判定
   ***************************/
  useEffect(() => {
    if (occuredError && errorData.current) {
      // コード期限切れエラーの場合、エラー画面へ遷移するため、ダイアログ表示しない
      if ((errorData.current.title !== 'error.expired_code_title')
        && (errorData.current.title !== 'error.max_check_attempts_reached_title')
        && (errorData.current.title !== 'error.system_error_title')
        && (errorData.current.title !== 'error.fetch_error_title')
        && (errorData.current.title !== 'error.invalid_operation_state_title')) {
        // エラーダイアログ表示
        Dialog({
          title: getTag(errorData.current.title),
          message: getTag(errorData.current.description),
          buttonLabel: getTag('passwordreset.close'),
          btn_action: closeDialog,
          btn_cancel: closeDialog
        });
      }
    }
  }, [occuredError, getTag]);

  // ===========================================================
  // Build HTML
  // ===========================================================
  // -------------------------------
  // 存在しないページへの遷移判定
  // -------------------------------  
  if (!user_data.return_url) {
    setGlobalError("page_not_found");
  }

  // -------------------------------
  // 表示コンテンツ対象判定
  // -------------------------------  
  return (<div id="bc_content_layer">
    {page_status.match(/^\/register\/form/) && <MailForm disableAcceptBtn={disableAcceptBtn} socialLogin={socialLogin} config={config} loadRegisterDocuments={loadRegisterDocuments} registerEmail={registerEmail} registerPhone={registerPhone} openDoc={openDoc} show_doc={show_doc} client_conns={client_conns} view_disabled={view_disabled} setOccuredError={setOccuredError} errorData={errorData} checkRecaptcha={checkRecaptcha} default_phone_region={default_phone_region} />}
    {page_status.match(/^\/register\/code/) && <CodeForm disableAcceptBtn={disableAcceptBtn} registerCode={registerCode} registerPhoneCode={registerPhoneCode} setOccuredError={setOccuredError} errorData={errorData} />}
    {page_status.match(/^\/register\/password/) && <PasswordForm disableAcceptBtn={disableAcceptBtn} registerUser={registerUser} registerPhoneUser={registerPhoneUser} config={config} openAdditionalTos={openAdditionalTos} show_doc={show_doc} checkPasswordPolicy={checkPasswordPolicy} password_valid={password_valid} setPasswordValid={setPasswordValid} setOccuredError={setOccuredError} errorData={errorData} />}
  </div>
  );
}

/**
 * 登録開始画面表示
 */
function MailForm({ config, disableAcceptBtn, socialLogin, loadRegisterDocuments, checkRecaptcha, registerEmail, registerPhone, setScrolleDown, show_doc, openDoc, client_conns, view_disabled, setOccuredError, errorData, default_phone_region }) {
  // ===========================================================
  // React Variables
  // ===========================================================
  // -----------------------------
  // Context
  // -----------------------------
  const { setTitle } = useContext(TitleContext);
  const { getTag, lang, tags } = useContext(LanguageContext);
  const { user_data } = useContext(UserDataContext);
  const { setPageStatus } = useContext(StatusContext);
  const { email_is_valid } = useContext(UtilContext);
  // -------------------------------
  // State
  // -----------------------------
  const [inputError, setInputError] = useState("");
  const [loginIdType, setloginIdType] = useState("");
  const [email, setEmail] = useState("");
  const [phone_cd, setPhoneCd] = useState("");
  const [phone, setPhone] = useState("");
  const [redirect, setRedirect] = useState("");
  const [processing, setProcessing] = useState(false);
  const [inactiveEmail, setInactiveEmail] = useState("inactive");
  const [inactivePhone, setInactivePhone] = useState("inactive");
  // -----------------------------
  // Ref
  // -----------------------------
  const regionRef = useRef("");
  const phoneLabelRef = useRef("");

  // ===========================================================
  // Base Difinitions
  // ===========================================================
  // Google reCAPTCHA
  const { executeRecaptcha } = useGoogleReCaptcha();

  // ===========================================================
  // Methods
  // ===========================================================
  const intersperse = (arr, separator) => {
    if (arr.length === 0) {
      return [];
    }

    return arr.slice(1).reduce((xs, x, i) => {
      return xs.concat([separator, x]);
    }, [arr[0]]);

  };

  /***************************
   * FAQからの復帰先URL生成
   ***************************/
  const getReturnToUrl = () => {
    const query = new URLSearchParams(window.location.search);
    query.set("first", "signup");
    const queryString = query.toString();
    const returnToUrl = `${window.location.protocol}//${window.location.host}/login?${queryString}`;
    return returnToUrl;
  };

  /***************************
   * メールアドレス入力検証
   * 
   * 問題なければ true
   * 問題がある場合 false
   ***************************/
  const validEmail = () => {
    // 入力チェック
    if (!email) {
      setInputError(getTag("error.empty_email"));
      return false;
    }

    // フォーマット検証
    if (!email_is_valid(email)) {
      setInputError(getTag("error.invalid_email"));
      return false;
    }
    return true;
  }

  /***************************
   * 電話番号入力検証
   * 
   * 問題なければ true
   * 問題がある場合 false
   ***************************/
  const validPhone = () => {
    // 入力チェック
    let errmsg = [];
    if (!regionRef.current) {
      errmsg.push(<span key="phone_empty_region">{getTag("error.empty_region")}</span>);
    }
    if (!phone) {
      if (!regionRef.current) {
        errmsg.push(<br key="phone_error_br" />);
      }
      errmsg.push(<span key="phone_empty_phone">{getTag("error.empty_phone")}</span>);
    }
    if (errmsg.length > 0) {
      setInputError(errmsg);
      return;
    }

    // フォーマット検証
    let phoneno = regionRef.current.replace("+", "") + phone;
    if (!(/^[0-9]+$/.test(phoneno))) {
      setInputError(getTag("error.invalid_phone"));
      return false;
    }

    if (phoneno.length < 8 || 15 < phoneno.length) {
      setInputError(getTag("error.invalid_phone"));
      return false;
    }
    return true;
  }

  /***************************
   * 登録処理
   ***************************/
  const registerLoginId = async () => {
    if (loginIdType === "phone") {
      // 電話番号対応
      if (!validPhone()) {
        return false;
      }
    }
    else {
      //　メールアドレス対応
      if (!validEmail()) {
        return false;
      }
    }

    setInputError("");
    setProcessing(true);
    let user_data = {
      agree: true,
      gtoken: null
    };
    try {
      // Captcha検証
      const token = await executeRecaptcha('yourAction');
      user_data.gtoken = token;
    }
    catch (err) {
      console.log(err.message);
      errorData.current = ErrorUtils.getErrorInfo(err);
      setOccuredError(true);
      setProcessing(false);
      return;
    }

    try {
      // 確認処理
      user_data["login_id_type"] = loginIdType;
      if (loginIdType === "phone") {
        user_data['phone_label'] = phoneLabelRef.current;
        user_data['phone_cd'] = phone_cd;
        user_data['phone_region'] = regionRef.current;
        user_data['phone_org'] = phone;
        user_data["phone"] = regionRef.current + phone;
        await registerPhone(user_data);
      }
      else {
        user_data["email"] = email;
        await registerEmail(user_data);
      }
      setRedirect("/register/code");
    }
    catch (err) {
      console.log(err.message);
      errorData.current = ErrorUtils.getErrorInfo(err);
      setOccuredError(true);
      setProcessing(false);
      return;
    }
    setProcessing(false);
  }

  /***************************
   * ログインID種別生成
   * 
   * 問題なければ 生成したReactDOM
   * 問題がある場合 null
   ***************************/
  const createLoginIdTypeElements = () => {
    let addLoginIDType = null;
    if (!view_disabled.disabledLoginIDType) {
      let email = getTag("register.type.email") ?? "メールアドレス（仮）";
      let phone = getTag("register.type.phone") ?? "電話番号（仮）";
      let checkedEmail = user_data.login_id_type === "email" ? "checked" : "";
      let checkedPhone = user_data.login_id_type === "phone" ? "checked" : "";
      addLoginIDType = [];
      addLoginIDType.push(
        <div id="LoginIDType" key="LoginIDType">
          <div>
            <input id="LoginIDTypeEmail" name="LoginIDTypeSelector" className="radio" type="radio" value="Email" onChange={onChangeLoginIDType} defaultChecked={checkedEmail} />
            <label className="radio_label" htmlFor="LoginIDTypeEmail">{email}</label>
          </div>
          <div>
            <input id="LoginIDTypePhone" name="LoginIDTypeSelector" className="radio" type="radio" value="Phone" onChange={onChangeLoginIDType} defaultChecked={checkedPhone} />
            <label className="radio_label" htmlFor="LoginIDTypePhone">{phone}</label>
          </div>
        </div>
      );
    }
    return addLoginIDType;
  }

  // -------------------------------
  // 国地域選択ボックスの生成
  // -------------------------------  
  const createRegionElements = (in_tmpRegionsNo, in_tmpRegionsLabel) => {
    let addRegionItems = [];
    let resId = "register.region_placeholder";
    let text = getTag(resId);
    //console.log(text);
    addRegionItems.push(<option key={resId} className="inactive">{text}</option>);
    if (in_tmpRegionsNo) {
      for (const [key, value] of Object.entries(in_tmpRegionsNo)) {
        let label = value;
        if (in_tmpRegionsLabel && in_tmpRegionsLabel[key]) {
          label += " " + in_tmpRegionsLabel[key];
          addRegionItems.push(<option key={key} value={key} data-phoneno={value}>{label}</option>);
        }
      }
    }
    //console.dir(addRegionItems);
    return addRegionItems;
  }

  /***************************
   * ソーシャルエリアの生成
   * 
   * 問題なければ 生成したReactDOM
   * 問題がある場合 null
   ***************************/
  const createSocialAreaElements = () => {
    let addSocialItems = [];
    if (!view_disabled.disabledSocial && client_conns !== undefined && client_conns !== null) {
      let tmpItems = [];
      for (let conn of client_conns) {
        let name = conn['name'];
        let cName = "social_" + name;
        let tag = "register.social." + name;
        let text = getTag(tag);
        if (text != null && text.length > 0) {
          tmpItems.push(<div id={name} key={cName} onClick={(ev) => { setProcessing(true); handleSocialSubmit(ev) }}><span key={tag} className={"icon-" + name + " social-button-" + name + " social-button-icon social_btn " + cName}>{text}</span></div>);
        }
      }
      if (tmpItems.length > 0) {
        let text = getTag("register.social_separator");
        let agreeText = getTag("register.social_text");
        addSocialItems.push(<div id="SocialArea" key="SocialArea" className="social" data-separator={text}><div className="agree-text">{agreeText}</div>{tmpItems}</div>);
      }
    }
    return addSocialItems;
  }

  // ===========================================================
  // Actions
  // ===========================================================
  // ----------------------------------------------------------
  // Event Triggers
  // ----------------------------------------------------------
  /***************************
   * ログインID種別
   ***************************/
  const onChangeLoginIDType = (ev) => {
    let elm = ev.currentTarget;
    let target = elm.value;
    let isEmail = "inactive";
    let isPhone = "";
    if (target === "Email") {
      isEmail = "";
      isPhone = "inactive";
    }
    setInputError("");
    setInactiveEmail(isEmail);
    setInactivePhone(isPhone);
    setloginIdType(target.toLowerCase());
    user_data["login_id_type"] = target.toLowerCase();
  }

  /***************************
   * メールアドレス欄
   ***************************/
  const onChangeEmail = (ev) => {
    let em = ev.target.value;
    setEmail(em);
  };
  const onBlurEmail = (ev) => {
    let em = ev.target.value;
    setEmail(em);
  };

  /***************************
   * 国・地域欄
   ***************************/
  const onChangeRegion = (ev) => {
    const target = ev.target.options[ev.target.selectedIndex];
    let region = target.dataset.phoneno;
    regionRef.current = region;
    setPhoneCd(target.value);
    phoneLabelRef.current = target.text;
  };

  /***************************
   * 電話番号欄
   ***************************/
  const onChangePhone = (ev) => {
    let val = ev.target.value.replace(/[^0-9]/g, "");
    ev.target.value = val;
    setPhone(val);
  };
  const onBlurPhone = (ev) => {
    setPhone(ev.target.value);
  };

  /***************************
   * 登録ボタン
   ***************************/
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    disableAcceptBtn("Registration");
    await registerLoginId();
    disableAcceptBtn("Registration", false);
  };

  /***************************
   * 規約表示ボタン
   ***************************/
  const handleDoc = async (doc) => {
    setProcessing(true);
    await openDoc(doc);

    setProcessing(false);
  };

  /***************************
   * 他画面遷移処理
   ***************************/
  const transLink = (in_target) => {
    user_data["phone_cd"] = phone_cd;
    setRedirect(in_target);
  };

  // ----------------------------------------------------------
  // useEffect
  // ----------------------------------------------------------
  useEffect(() => {
    (async () => {
      if (user_data.email) {
        setEmail(user_data.email);
      }
      if (user_data.phone_label) {
        phoneLabelRef.current = user_data.phone_label;
      }
      if (user_data.phone_cd) {
        setPhoneCd(user_data.phone_cd);
      }
      if (user_data.phone_region) {
        regionRef.current = user_data.phone_region;
      }
      if (user_data.phone_org) {
        setPhone(user_data.phone_org);
      }
      if (user_data.login_id_type) {
        setInactiveEmail(user_data.login_id_type === "email" ? "" : "inactive");
        setInactivePhone(user_data.login_id_type === "phone" ? "" : "inactive");
        setloginIdType(user_data.login_id_type);
      }

      setTitle(getTag("register.header_title"));
    })();
  }, [user_data, setTitle, getTag, lang]);

  /***************************
   * リダイレクト遷移判定処理
   ***************************/
  useEffect(() => {
    if (redirect) {
      setPageStatus(redirect);
    }
  }, [redirect, setPageStatus]);

  // ===========================================================
  // Build HTML
  // ===========================================================

  // -------------------------------
  // 規約画面構築判定
  // -------------------------------
  let tos_links = config.agreement.register.filter(doc => doc.TOS).map(
    (doc) => <p key={doc.document_id}><button className="link agreement tos" onClick={() => handleDoc(doc)} disabled={processing}><span>{getTag(`register.agreement.documents.${doc.document_id}`)}</span></button></p>
  );

  let documents_links = config.agreement.register.filter(doc => !doc.TOS).map(
    (doc) => <button key={doc.document_id} className="link agreement" onClick={() => handleDoc(doc)} disabled={processing}>{getTag(`register.agreement.documents.${doc.document_id}`)}</button>
  );
  documents_links = intersperse(documents_links, " | ");

  const handleSocialSubmit = async (ev) => {
    ev.preventDefault();

    socialLogin(ev.currentTarget.id);
  }

  // -------------------------------
  // ログインID種別生成
  // -------------------------------
  let addLoginIDType = createLoginIdTypeElements();

  // -------------------------------
  // デフォルト国番号の判定と生成
  // 1. 国番号と国コードが設定されている場合、マスタに直接存在確認をする
  // 2. 国番号しかない場合、番号のみで存在確認をする
  // -------------------------------  
  const tmpRegionsNo = tags[lang].common.regions_no;
  const tmpRegionsLabel = tags[lang].common.regions_label;
  //console.dir(tmpRegionsNo);
  //console.dir(tmpRegionsLabel);
  //console.dir(default_phone_region);
  let defRegKey = phone_cd ?? null;
  let defRegPre = "phone_no_";
  let defRegNo = null;
  if (default_phone_region && default_phone_region.no) {
    defRegNo = default_phone_region.no
  }
  let defRegCountry = null;
  if (default_phone_region && default_phone_region.country) {
    defRegCountry = default_phone_region.country.toUpperCase();
  }
  //console.log(defRegNo);
  //console.log(defRegCountry);
  if (defRegNo && defRegCountry) {
    defRegKey = defRegPre + defRegCountry + "_" + defRegNo;
    if (!tmpRegionsNo[defRegKey]) {
      defRegKey = "";
    }
  }
  else if (defRegNo && !defRegKey) {
    let res = Object.entries(tmpRegionsNo).find(([key, value]) => key.endsWith("_" + defRegNo));
    //console.log(res);
    if (res) {
      defRegKey = res[0];
    }
  }
  //console.log(defRegKey);
  if (defRegKey && !phone_cd) {
    //console.log(tmpRegionsNo[defRegKey]);
    let no = tmpRegionsNo[defRegKey];
    let label = tmpRegionsLabel[defRegKey];
    regionRef.current = tmpRegionsNo[defRegKey];
    setPhoneCd(defRegKey);
    phoneLabelRef.current = no + " " + label;
  }

  // -------------------------------
  // 国地域選択ボックスの生成
  // -------------------------------  
  let addRegionItems = createRegionElements(tmpRegionsNo, tmpRegionsLabel);

  // -------------------------------
  // ソーシャルエリアの生成
  // -------------------------------
  let addSocialItems = createSocialAreaElements();

  // -------------------------------
  // 規約画面構築判定
  // -------------------------------
  if (show_doc.document_id) {
    return (<div>
      <div id="Documents" className="form">
        <h1 className="title">{getTag(`register.agreement.documents.${show_doc.document_id}`)}</h1>
        <div id="Document">
          <p className="description" dangerouslySetInnerHTML={{ __html: show_doc.content }} />
        </div>
        <div className="spacer"> </div>
        <div className="action_area">
          <p className="action_btn"><button className="btn_l acceptbtn" onClick={() => openDoc({})}>{getTag("common.return")}</button></p>
        </div>
      </div>
    </div>
    );
  }

  // -------------------------------
  // 表示画面構築
  // -------------------------------
  return (
    <div id="Registration" className="form">
      <h1 className="title">{getTag("register.title")}</h1>
      <div className="input_area">
        {addLoginIDType}
        <p id="LoginIDTypeInputEmail" className={inactiveEmail}>
          <label htmlFor="email">{getTag("register.email.title")}</label>
          <input type="email" id="email" name="email" placeholder={getTag("register.email.placeholder")} defaultValue={email} onChange={onChangeEmail} onBlur={onBlurEmail} disabled={processing} />
        </p>
        <p id="LoginIDTypeInputPhone" className={inactivePhone}>
          <label htmlFor="regions">{getTag("register.region_title")}</label>
          <select name="regions" value={defRegKey} onChange={(ev) => onChangeRegion(ev)}>
            {addRegionItems}
          </select>
          <label htmlFor="phone">{getTag("register.phone.title")}</label>
          <input type="tel" id="phone" name="phone" placeholder={getTag("register.phone.placeholder")} defaultValue={phone} onChange={onChangePhone} onBlur={onBlurPhone} disabled={processing} maxLength={15} />
        </p>
      </div>
      {inputError && <div id="Notification" className="error">{inputError}</div>}
      <div className="documentlinklist">
        <p className="description">{getTag("register.agreement.text")}</p>
        <div className="TOS">{tos_links}</div>
        <div className="policy">{documents_links}</div>
      </div>
      <div className="action_area">
        <p className="action_btn"><button className="btn_l acceptbtn" onClick={handleSubmit}>{getTag("register.button")}</button></p>
      </div>
      <div className="linklist">
        {!view_disabled.disabledLogin && <button className="link agreement" onClick={() => transLink("/login")}><span>{getTag("register.additional_anchor1")}</span></button>}
        <p><button className="link agreement" onClick={() => window.location.href = `${AppConfig.NEWS_URL}/faq?client_id=${config.client_id}&return_url=${encodeURIComponent(getReturnToUrl())}`}><span>{"FAQ"}</span></button></p>
      </div>
      {addSocialItems}
    </div>
  );
}

/**
 * コード確認画面表示
 */
function CodeForm({ disableAcceptBtn, registerCode, registerPhoneCode, setOccuredError, errorData }) {
  // ===========================================================
  // React Variables
  // ===========================================================
  // -----------------------------
  // Context
  // -----------------------------
  const { setTitle } = useContext(TitleContext);
  const { getTag, lang } = useContext(LanguageContext);
  const { user_data } = useContext(UserDataContext);
  const { setPageStatus } = useContext(StatusContext);
  // -----------------------------
  // State
  // -----------------------------
  const [inputError, setInputError] = useState("");
  const [code, setCode] = useState("");
  const [redirect, setRedirect] = useState("");
  const [processing, setProcessing] = useState(false);
  const [sent_message, setSentMessage] = useState("");

  // ===========================================================
  // Actions
  // ===========================================================
  // ----------------------------------------------------------
  // Event Triggers
  // ----------------------------------------------------------
  /***************************
   * 確認ボタン有効判定処理
   ***************************/
  const canSubmit = (ev) => {
    let res = (!processing) && code.match(/^\d{6}$/);
    disableAcceptBtn("Registration", !res);
    return res;
  }

  /***************************
   * 確認ボタン
   ***************************/
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);
    try {
      let resState = null;
      if (user_data["login_id_type"] === "phone") {
        resState = await registerPhoneCode(code);
      }
      else {
        resState = await registerCode(code);
      }
      if (resState !== null) {
        setRedirect("/register/password");
      } else {
        setInputError('invalid_code');
        // コントロール活性
        setProcessing(false);
      }
    } catch (err) {
      console.log(err.message);

      errorData.current = ErrorUtils.getErrorInfo(err);
      setOccuredError(true);

      // コントロール活性
      setProcessing(false);
    }
  };

  // ----------------------------------------------------------
  // useEffect
  // ----------------------------------------------------------
  /***************************
   * 画面表示初期処理
   ***************************/
  useEffect(() => {
    setTitle(getTag("register.header_title"));

    let loginIdType = user_data.login_id_type;
    if (loginIdType === "phone") {
      if (!user_data.phone || !user_data.token) {
        setRedirect("/register/form");
      }
    }
    else {
      if (!user_data.email || !user_data.token) {
        setRedirect("/register/form");
      }
    }
  }, [user_data, setTitle, getTag, lang]);

  /***************************
   * リダイレクト遷移判定処理
   ***************************/
  useEffect(() => {
    if (redirect) {
      setPageStatus(redirect);
    }
  }, [redirect, setPageStatus]);

  /***************************
   * 画面表示文言判定
   ***************************/
  useEffect(() => {
    let sent_message = getTag("register.code.mail_sent");
    if (user_data.login_id_type === "phone") {
      sent_message = getTag("register.code.sms_sent");
    }
    setSentMessage(sent_message);
  }, [sent_message, getTag, user_data]);

  // ===========================================================
  // Build HTML
  // ===========================================================
  // -------------------------------
  // エラー画面構築判定
  // -------------------------------
  if (errorData.current) {
    if (errorData.current.title === "error.expired_code_title") {
      return <ErrorComponent title={errorData.current.title} error={errorData.current.description} redirect_to={"/register/form"} />;
    }
    else if (errorData.current.title === "error.max_check_attempts_reached_title") {
      return <ErrorComponent title={errorData.current.title} error={errorData.current.description} redirect_to={"/register/form"} />;
    }
  }

  // -------------------------------
  // 表示画面構築
  // -------------------------------
  return (
    <div id="Registration" className="form">
      <div className="input_area">
        <h1 className="title">{getTag("register.code.title")}</h1>
        <p className="description">
          {sent_message}<br />
          {getTag("register.code.text")}<br />
          {getTag("register.code.text2")}
        </p>
        <p>
          <label htmlFor="code">{getTag("register.code.code")}</label>
          <input type="text" id="code" name="code" placeholder={getTag("register.code.placeholder")} onChange={(ev) => setCode(ev.target.value)} disabled={processing} maxLength={6} />
        </p>
      </div>
      {inputError && <div id="Notification" className="error">{getTag("error." + inputError)}</div>}
      <div className="action_area">
        <p className="action_btn"><button className="btn_l acceptbtn disabledbtn" disabled={!canSubmit()} onClick={handleSubmit}>{getTag("register.code.button")}</button></p>
      </div>
      <div className="linklist">
        <button className="link" onClick={() => setRedirect("/register/form")}><span>{getTag("common.return")}</span></button>
      </div>
    </div>
  );
}

/**
 * パスワード設定画面表示
 */
function PasswordForm({ disableAcceptBtn, registerUser, registerPhoneUser, config, openAdditionalTos, show_doc, checkPasswordPolicy, setOccuredError, errorData }) {
  // ===========================================================
  // React Variables
  // ===========================================================
  // -----------------------------
  // Context
  // -----------------------------
  const { setTitle } = useContext(TitleContext);
  const { getTag, lang, tags } = useContext(LanguageContext);
  const { user_data } = useContext(UserDataContext);
  const { generateInternalRedirect } = useContext(UtilContext);
  const { setPageStatus } = useContext(StatusContext);
  // -----------------------------
  // State
  // -----------------------------
  const [inputError, setInputError] = useState("");
  const [country, setCountry] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [redirect, setRedirect] = useState("");
  const [tos, setTos] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [inactiveEmail] = useState(user_data.login_id_type === "email" ? "" : "inactive");
  const [inactivePhone] = useState(user_data.login_id_type === "phone" ? "" : "inactive");
  const [additonalAgreements, setAdditonalAgreements] = useState({});  // 追加同意文チェックボックスのチェック状態
  // -----------------------------
  // REf
  // -----------------------------
  const passwordPreRef = useRef("");
  const errRedirect = useRef(false);
  const registerValidRef = useRef(false);

  // ===========================================================
  // Methods
  // ===========================================================
  const login = async () => {
    setProcessing(true);
    let username = user_data.email;
    localStorage.setItem('Email', user_data.email);
    if (user_data.login_id_type === "phone") {
      username = user_data.phone_registerd;
      localStorage.setItem('phone', user_data.phone_org);
      localStorage.setItem('phone_cd', user_data.phone_cd);
    }

    const auth_params = {
      overrides: {
        __tenant: config.auth0Tenant,
        __token_issuer: config.authorizationServer.issuer
      },
      domain: config.domain,
      clientID: config.client_id,
      responseType: "code",
      redirectUri: user_data.return_url,
      audience: config.audience,
      ...config.internalOptions
    };

    window.history.replaceState("", "", "/login");
    let auth = new auth0.WebAuth(auth_params);
    const login_data = { username: username, password: password, realm: config.realm };

    auth.login(login_data, (err) => {
      console.log(err);
      setInputError("system_error");
      setProcessing(false);
      errRedirect.current = true;
    });
  };

  const passwordInputType = () => {
    if (passwordShown) {
      return 'text';
    } else {
      return 'password';
    }
  };

  // -----------------------------------------
  // パスワードチェック
  // -----------------------------------------
  const isValidPassword = async (in_password) => {
    // パスワードが未入力の場合はエラーで中断
    if (!in_password) {
      // 前回入力の記録用に保持
      passwordPreRef.current = in_password;
      // 未入力エラー
      return "empty_password";
    }

    // パスワード入力の事前チェック
    // パスワードの入力が前回と同じか否かチェックする
    // また、パスワード長のチェックを行う
    if ((in_password === passwordPreRef.current)
      || (in_password.length <= 7 || in_password.length >= 65)) {
      // ポリシーエラーとなった前回のパスワード入力を記録
      passwordPreRef.current = in_password;
      // パスワードポリシーエラー
      return "invalid_pass_2";
    }

    // パスワードポリシーの本チェック
    // ポリシーエラーの場合、falseが返却されポリシーエラーとする
    // 何らかの理由でポリシーチェックが完了しない場合は発生した内容のエラーとする
    let errId = null;
    try {
      const res = await checkPasswordPolicy(in_password, "");
      if (!res) {
        // ポリシーエラーとなった前回のパスワード入力を記録
        passwordPreRef.current = in_password;
        // パスワードポリシーエラー
        errId = "invalid_pass_2";
      }
    }
    catch (err) {
      console.log(err.message);
      // ポリシー以外のエラー
      errorData.current = ErrorUtils.getErrorInfo(err);
      errId = errorData.current.code;
    }

    // 本ポリシーチェックの結果確認
    if (errId) {
      // 本ポリシーエラー
      return errId;
    }

    // 前回のパスワード入力を記録
    passwordPreRef.current = in_password;

    return true;
  }

  // ===========================================================
  // Actions
  // ===========================================================
  // ----------------------------------------------------------
  // Event Triggers
  // ----------------------------------------------------------
  /***************************
   * パスワード欄
   ***************************/
  const onChangePassword = (ev) => {
    let pw = ev.target.value;
    setPassword(pw);
  };

  /***************************
   * パスワード表示欄
   ***************************/
  const onChangePasswordShown = (ev) => {
    const passwordShown = ev.target.checked;
    setPasswordShown(passwordShown);
  };

  /***************************
   * 居住国欄
   * 居住国を変更した際の処理
   ***************************/
  const handleCountryChange = (ev) => {
    const new_country = ev.target.value
    setCountry(new_country);

    // 居住国をチェック
    if (Object.keys(config.additional_agreement).includes(new_country)) { // 再同意が必要な場合
      // TOSを取得してセット
      const tos = config.additional_agreement[new_country][0]
      setTos(tos);
    } else { // 再同意が不要な場合
      // TOSをクリア
      setTos("");
    }
  };

  /***************************
   * 登録ボタン or 利用規約を確認ボタン
   ***************************/
  const handleSubmit = async (ev) => {
    ev.preventDefault();

    // エラー状態を初期化
    let errPassword = null;
    let errCountry = null;

    // 処理開始
    disableAcceptBtn("Registration");
    setProcessing(true);
    // エラークリア
    setInputError("");

    if (!registerValidRef.current) {
      // -----------------------------------------
      // パスワードチェック
      // -----------------------------------------
      let resPass = await isValidPassword(password);
      if (resPass !== true) {
        // パスワードチェックエラー
        errPassword = resPass;
        if (errorData.current) {
          // エラー画面遷移が必要な場合はここで終了
          setOccuredError(true);
          setProcessing(false);
          return;
        }
      }

      // -----------------------------------------
      // 居住国チェック
      // -----------------------------------------
      if (!country) {
        // 未入力エラー
        errCountry = "empty_country";
      }

      // -----------------------------------------
      // エラー表示判定
      // -----------------------------------------
      let tmpInputError = [];
      if (errPassword) {
        tmpInputError.push(<span key="password_error">{getTag("error." + errPassword)}</span>);
      }
      if (errCountry) {
        if (tmpInputError.length >= 1) {
          tmpInputError.push(<br key="input_error_br" />);
        }
        tmpInputError.push(<span key="country_error">{getTag("error." + errCountry)}</span>);
      }
      if (tmpInputError.length >= 1) {
        // 画面復帰
        disableAcceptBtn("Registration", false);
        setProcessing(false);
        // エラー設定
        setInputError(tmpInputError);
        return;
      }
      // チェック完了
      registerValidRef.current = true;
    }

    // -----------------------------------------
    // 登録処理
    // -----------------------------------------
    // 再同意が必要な場合
    if (tos && !show_doc.document_id) {
      // 利用規約を表示
      await openAdditionalTos(tos, country);
      // 画面復帰
      setProcessing(false);
      disableAcceptBtn("Registration", false);
      return;
    }

    // 追加規約画面表示中
    if (tos && show_doc.document_id) {
      // 追加規約がすべてチェックされていなければエラー（ボタンの非活性制御は行っているが、開発ツールでatrributeを編集すればクリックできる）
      if (show_doc.agreement_items) {
        const shouldAgree = Object.keys(additonalAgreements).filter((key) => additonalAgreements[key] === false).length > 0;
        if (shouldAgree) {
          // 画面復帰
          setProcessing(false);
          // エラー設定
          setInputError(getTag("error.not_agreed"));
          disableAcceptBtn("Documents");
          return;
        }
      }
      // ボタン連打防止制御
      disableAcceptBtn("Documents");
    }

    // 再同意が不要な場合
    // 登録処理を実行
    try {
      let data = {
        token: user_data.token,
        password: password,
        country: country
      };

      if (user_data.login_id_type === "phone") {
        data['phone_cd'] = user_data.phone_cd;
        data['phone_region'] = user_data.phone_region;
        data['phone_org'] = user_data.phone_org;
        data['phone'] = user_data.phone;
        await registerPhoneUser(data);
      }
      else {
        data['email'] = user_data.email;
        await registerUser(data);
      }

      login();
    }
    catch (err) {
      console.log(err.message);
      errorData.current = ErrorUtils.getErrorInfo(err);
      // 画面復帰
      setOccuredError(true);
      setProcessing(false);
      disableAcceptBtn("Registration", false);
      // 追加規約画面表示中
      if (tos && show_doc.document_id) {
        disableAcceptBtn("Documents", false);
      }
    }
  };

  /***************************
   * 利用規約戻るボタン
   * 利用規約画面にて戻るボタンを押下した際の処理
   ***************************/
  const handleReturn = (ev) => {
    // エラー状態をクリア
    setOccuredError(false);
    errorData.current = null;
    setInputError("");
    // パスワード入力情報をクリア
    setPassword("");
    passwordPreRef.current = "";
    setPasswordShown(false);
    // パスワード入力画面に戻る（利用規約を非表示にする）
    openAdditionalTos({});
    // 追加同意文チェックボックス状態をクリア
    setAdditonalAgreements({});
    // 入力チェック済みを解除
    registerValidRef.current = false;
  };

  /***************************
   * 追加同意文チェックボックスクリック
   ***************************/
  const onChangeAdditonalAgreement = (ev) => {
    const checked = ev.target.checked;
    const elementId = ev.target.id;
    setAdditonalAgreements((preSetting) => ({
      ...preSetting,
      [elementId]: checked
    }));
  };

  // ----------------------------------------------------------
  // useEffect
  // ----------------------------------------------------------
  /***************************
   * 言語設定を変更した際の処理
   ***************************/
  useEffect(() => {
    (async () => {
      if (tos && show_doc.document_id) { // 利用規約が表示されている場合
        // 選択した言語の利用規約を再取得
        setProcessing(true);
        await openAdditionalTos(tos, country);
        setProcessing(false);
      }
    })()
    // ignore useEffect has a missing dependency: 'openAdditionalTos'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, country, show_doc.document_id, tos]);


  /***************************
   * 画面表示初期処理
   ***************************/
  useEffect(() => {
    setTitle(getTag("register.header_title"));

    let loginIdType = user_data.login_id_type;
    if (loginIdType === "phone") {
      if (!user_data.phone || !user_data.token || !user_data.code_confirmed) {
        setRedirect("/register/form");
      }
    }
    else {
      if (!user_data.email || !user_data.token || !user_data.code_confirmed) {
        //setRedirect(generateInternalRedirect("/register/form/"));
        setRedirect("/register/form/");
      }
    }

  }, [generateInternalRedirect, user_data, setTitle, getTag, lang]);

  /***************************
   * 追加同意文チェック状態初期化処理
   ***************************/
  useEffect(() => {
    if (tos && show_doc.document_id) {
      const checkedStatus = {};
      if (show_doc.agreement_items) {
        for (const resourceKey of show_doc.agreement_items) {
          checkedStatus[resourceKey] = false;
        }
      }
      setAdditonalAgreements(checkedStatus)
    }
  }, [tos, show_doc.document_id, show_doc.agreement_items]);

  /***************************
   * 追加同意文チェックボックスチェックによるボタン活性制御
   ***************************/
  useEffect(() => {
    if (!tos || !show_doc.document_id) {
      // 規約同意画面表示中以外は何もしない
      return;
    }
    if (!additonalAgreements || Object.keys(additonalAgreements).length === 0) {
      // 追加同意文が無い場合、「規約に同意して登録」は活性
      disableAcceptBtn("Documents", false);
      return;
    }
    // 追加同意文がある場合、未チェックがあれば非活性
    const disabled = Object.keys(additonalAgreements).filter(elementId => additonalAgreements[elementId] === false).length > 0;
    disableAcceptBtn("Documents", disabled);
    if (!disabled) {
      setInputError("");
    }
    // ignore useEffect has a missing dependency: 'disableAcceptBtn'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additonalAgreements, tos, show_doc.document_id]);

  /***************************
   * リダイレクト遷移判定処理
   ***************************/
  useEffect(() => {
    if (redirect) {
      setPageStatus(redirect);
    }
  }, [redirect, setPageStatus]);

  // ===========================================================
  // Build HTML
  // ===========================================================
  // -------------------------------
  // 国リソースを扱いやすいようMap化
  // -------------------------------
  const countries = tags[lang].common.countries;
  //console.log("################################## country map");
  //console.dir(countries);
  let tmpCountries = {};
  for (const data of countries) {
    for (const [key, value] of Object.entries(data)) {
      tmpCountries[key] = value;
    }
  }
  //console.dir(tmpCountries);
  // -------------------------------
  // ソート準備
  // -------------------------------
  // ソート用配列化
  let sortitems = Object.keys(tmpCountries).map((k) => ({ key: k, value: tmpCountries[k] }));
  // ソート（アルファベット順）
  sortitems.sort(function (a, b) {
    let ta = a.key.toString().toLowerCase();
    let tb = b.key.toString().toLowerCase();
    if (ta < tb) {
      return -1;
    }
    else if (ta > tb) {
      return 1;
    }
    return 0;
  });
  // 再Map化
  tmpCountries = Object.assign({}, ...sortitems.map((item) => ({
    [item.key]: item.value,
  })));
  //console.dir(tmpCountries);
  // -------------------------------
  // 国選択ボックスの生成
  // -------------------------------
  let addCountryItems = [];
  let resId = "register.password.country_placeholder";
  let text = getTag(resId);
  //console.log(text);
  addCountryItems.push(<option key={resId} className="inactive">{text}</option>);
  for (const [key, value] of Object.entries(tmpCountries)) {
    addCountryItems.push(<option key={key} value={key}>{value}</option>);
  }
  //console.dir(addCountryItems);

  // お住まいの国のデフォルト設定判定（電話番号時）
  let defaultCountryCd = "";
  if (user_data.login_id_type === "phone") {
    if (country) {
      defaultCountryCd = country;
    }
    else {
      let targetCd = user_data.phone_cd.split("_")[2];
      let res = Object.entries(tmpCountries).find(([key, value]) => targetCd.toUpperCase() === key);
      if (res) {
        defaultCountryCd = res[0];
        setCountry(defaultCountryCd);
      }
    }
  }
  else {
    if (country) {
      defaultCountryCd = country;
    }
  }

  // エラー画面遷移
  if (errorData.current) {
    if ((errorData.current.title === "error.system_error_title")
      || (errorData.current.title === "error.fetch_error_title")
      || (errorData.current.title === "error.invalid_operation_state_title")) {
      return <ErrorComponent title={errorData.current.title} error={errorData.current.description} redirect_to={"/register/form"} />;
    }
  }

  // -------------------------------
  // 規約画面構築判定
  // show_docの値に応じて利用規約を表示
  // -------------------------------
  if (show_doc.document_id) {
    let agreementsDiv = <React.Fragment></React.Fragment>;
    if (show_doc.agreement_items && show_doc.agreement_items.length > 0) {
      const statements = [];
      for (const resourceKey of show_doc.agreement_items) {
        statements.push(<input type="checkbox" id={resourceKey} key={resourceKey} onChange={onChangeAdditonalAgreement} disabled={processing} />);
        statements.push(<span id={`span.${resourceKey}`} key={`span.${resourceKey}`}><label htmlFor={resourceKey}>{getTag(resourceKey, true)}</label></span>);
      }
      agreementsDiv =
        <div id="additional_agreement" className="listblock">
          <p className="description"><label>{getTag(show_doc.agreement_header)}</label></p>
          <div id="agreement_items">
            {statements}
          </div>
        </div>
    }
    return (<div>
      <div id="Documents" className="form">
        <h1 className="title">{getTag("register.title")}</h1>
        <div id="Document">
          <p className="description" dangerouslySetInnerHTML={{ __html: show_doc.content }} />
        </div>
        {agreementsDiv}
        <div className="spacer"> </div>
        {inputError && <div id="Notification" className="error">{inputError}</div>}
        <div className="action_area">
          <p className="action_btn"><button className="btn_l acceptbtn" onClick={handleSubmit}>{getTag("register.button2")}</button></p>
        </div>
        <div className="linklist thickbottom">
          <p className="link"><button className="link" onClick={handleReturn}>{getTag("common.return")}</button></p>
        </div>
      </div>
    </div>
    );
  }

  // -------------------------------
  // 表示画面構築
  // -------------------------------
  return (
    <div id="Registration" className="form">
      <div className="input_area">
        <h1 className="title">{getTag("register.title")}</h1>
        <p className="description">
          {getTag("register.password.text")}<br />
          {!tos && getTag("register.password.text2")}
          {tos && getTag("register.password.text3")}
        </p>
        <p id="LoginIDTypeInputEmail" className={inactiveEmail}>
          <label htmlFor="email">{getTag("register.password.email")}</label>
          <input type="email" id="email" name="email" className="input_inactive" value={user_data.email} disabled />
        </p>
        <p id="LoginIDTypeInputPhone" className={inactivePhone}>
          <label htmlFor="phone">{getTag("register.phone.title")}</label>
          <input type="tel" id="phone" name="phone" className="input_inactive" value={user_data.phone_use} disabled />
        </p>
        <p>
          <label htmlFor="password">{getTag("register.password.password")}</label>
          <input type={passwordInputType()} id="password" name="password" placeholder={getTag("register.password.password_placeholder")} onChange={onChangePassword} disabled={processing} />
          <input type="checkbox" id="showPassword" onChange={onChangePasswordShown} /><label htmlFor="showPassword" id="showPasswordLabel">{getTag("register.password.show_password")}</label>
        </p>
        <p>
          <label htmlFor="country">{getTag("register.password.country")}</label>
          <select name="country" defaultValue={defaultCountryCd} onChange={(ev) => handleCountryChange(ev)}>
            {addCountryItems}
          </select>
        </p>
      </div>
      {inputError && <div id="Notification" className="error">{inputError}</div>}
      <div className="action_area">
        <div className={"description " + inactivePhone}>
          <p>{getTag("register.password.register_info1")}</p>
          <p>{getTag("register.password.register_info2")}</p>
          <p>{getTag("register.password.register_info3")}</p>
        </div>
        <p className="action_btn">
          <button className="btn_l acceptbtn" onClick={handleSubmit}>
            {!tos && getTag("register.password.button")}
            {tos && getTag("register.password.confirm_tos_button")}
          </button>
        </p>
      </div>
    </div>
  );
}
